class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.availableOptionCombinations = this.buildAvailabilityMap();
    this.updateVariantAvailability();
    this.addEventListener('change', this.onRadioChange.bind(this));
  }

  onRadioChange(event) {
    const seatSelector = this.querySelector('#main-product.content-section fieldset.seats');
    const isSeatNumberChange = seatSelector?.contains(event.target) || false;
    const productSelector = this.querySelector('#main-product.content-section fieldset.sectionals');
    const isProductChange = productSelector?.contains(event.target) || false;
    const layoutSelector = this.querySelector('#main-product.content-section');
    const isLayoutChange = layoutSelector?.contains(event.target) || false;
    const modelSelector = this.querySelector('#model.content-section fieldset');
    const isModelChange = modelSelector?.contains(event.target) || false;

    this.updateOptions();
    this.updateVariantAvailability();
    if (isSeatNumberChange) {
      this.updateSeatsDescription(event.target);
      this.updateSectionals(event.target.value);
      const selectedSectional = this.getSelectedSectional();
      const selectedVariant = this.getVariantFromProduct(selectedSectional.dataset.productId);
      this.showProduct(selectedSectional.dataset.productId, selectedSectional.dataset.url, selectedVariant.id);
    }
    if (isProductChange) {
      const selectedVariant = this.getVariantFromProduct(event.target.dataset.productId);
      this.updateSectionalsText(event.target);
      this.showProduct(event.target.dataset.productId, event.target.dataset.url, selectedVariant.id);
    }
    if (isLayoutChange) {
      this.updateCurrentProductId(true);
    }
    if (this.currentProductId && !isModelChange) {
      this.updateModelPrices();
    }
    if (this.currentProductId && this.currentVariant) {
      this.updateStickyHeaderTitle();
      this.updateStickyHeaderPrice();
      this.updateStickyHeaderImage();
    }
    if (!this.currentProductId) {
      this.updateCheckoutLabel();
    }
  }

  getVariantFromProduct(productId) {
    const selectedVariant = this.getVariantData(productId).find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    if (!selectedVariant) return;
    if (productId == this.currentProductId) {
      this.currentVariant = selectedVariant;
    }
    return selectedVariant;
  }

  getSelectedSectional() {
    const visibleSectional = this.querySelector('.sectionals form:not(.hidden)');
    let selectedSectional = visibleSectional.querySelector('input:checked') || visibleSectional.querySelector('input');
    selectedSectional.checked = true;
    return selectedSectional;
  }

  updateSeatsDescription(target) {
    const seatsDescription = target.dataset.description || '',
      formLabel = this.querySelector('.form__label #selected-number-of-seats-description');
    formLabel && (formLabel.innerHTML = seatsDescription);
  }

  updateSectionalsText(target) {
    const sectionalsText = target.dataset.sectionalsText || '',
      formLabel = this.querySelector('.form__label #selected-sectionals-text');
    formLabel && (formLabel.innerHTML = sectionalsText);
  }

  updateSectionals(value) {
    const hiddenSectionals = this.querySelectorAll(`.sectionals form:not(#seats-${value})`);
    const visibleSectional = this.querySelector(`#seats-${value}`);
    (hiddenSectionals.forEach((element) => element.classList.add('hidden')),
      visibleSectional.classList.remove('hidden'));
    let checkedSectional = visibleSectional.querySelector('input:checked');
    if (!checkedSectional) {
      checkedSectional = visibleSectional.querySelector('input');
      checkedSectional.setAttribute('checked', true);
    }
    this.updateSectionalsText(checkedSectional);
  }

  showProduct(productId, url, variantId) {
    this.currentProductId = productId;
    this.dataset.url = url;
    const productUrl = variantId ? `${url}?variant=${variantId}` : url;
    window.history.replaceState({}, '', productUrl);

    const mediaGalleries = document.querySelectorAll('.product__media-gallery');
    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.classList.add('hidden');
      if (mediaGallery.id == `MediaGallery-${productId}`) {
        mediaGallery.classList.remove('hidden');
      }
    });
    this.onVariantChange();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.seats, .sectionals)'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateModelPrices() {
    const modelFieldSet = this.querySelector('#model fieldset');
    // Index of the "Model" option in the configurator;
    const modelOptionIndex = parseInt(modelFieldSet.dataset.optionIndex || 2);
    if (!modelFieldSet) return;
    const currentVariants = this.getVariantData(this.currentProductId);
    const modelVariants = currentVariants.filter((variant) => {
      return !variant.options
        .toSpliced(modelOptionIndex, 1)
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    modelVariants.forEach((modelVariant) => {
      const optionPriceLabel = modelFieldSet.querySelector(
        `.product-form__input-wrapper [value="${modelVariant.options[modelOptionIndex]}"]+label .price-wrapper.price__container`,
      );
      optionPriceLabel.dataset.price = modelVariant.price;
      optionPriceLabel.dataset.comparedAt = modelVariant.compare_at_price || '';
      const currencyCodeEnabled = optionPriceLabel.dataset.currencyCodeEnabled || '' === 'true';
      optionPriceLabel.querySelector('.current-price').innerHTML = currencyCodeEnabled
        ? formatWithCurrency(modelVariant.price)
        : formatPrice(modelVariant.price);
      optionPriceLabel.querySelector('.compare-at').innerHTML = currencyCodeEnabled
        ? formatWithCurrency(modelVariant.compare_at_price)
        : formatPrice(modelVariant.compare_at_price);
    });
  }

  buildAvailabilityMap() {
    const variantData = this.getVariantData();
    if (!variantData) return new Map();
    const availabilityMap = new Map();
    variantData.forEach((variant) => {
      const options = variant.options;
      options.forEach((option, optionIndex) => {
        if (!availabilityMap.has(optionIndex)) {
          availabilityMap.set(optionIndex, new Map());
        }
        const optionMap = availabilityMap.get(optionIndex);
        if (!optionMap.has(option)) {
          optionMap.set(option, variant.available);
        } else {
          optionMap.set(option, optionMap.get(option) || variant.available);
        }
      });
    });
    return availabilityMap;
  }

  updateVariantAvailability() {
    if (!this.availableOptionCombinations) return;

    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.seats, .sectionals)'));
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const radios = Array.from(fieldset.querySelectorAll("input[type='radio']"));
      const optionMap = this.availableOptionCombinations.get(fieldsetIndex);
      if (!optionMap) return;
      radios.forEach((radio) => {
        const optionValue = radio.value;
        const isAvailable = optionMap.get(optionValue);
        if (isAvailable === false) {
          radio.setAttribute('disabled', '');
          radio.nextElementSibling.classList.add('sold-out');
        } else {
          radio.removeAttribute('disabled');
          radio.nextElementSibling.classList.remove('sold-out');
        }
      });
    });
  }

  updateCheckoutLabel() {
    if (!this.currentVariant) return;

    const labelElement = this.querySelector('.addon-availability-text');
    if (!labelElement) return;

    const availabilityText = this.currentVariant.availability_text;

    if (labelElement) {
      labelElement.dataset.isPreorder = this.currentVariant.is_preorder;
      labelElement.textContent = availabilityText;
      labelElement.style.display = 'block';
    }
  }

  updateStickyHeaderTitle() {
    // Update mobile sticky header product name when variant changes
    const mobileHeaderTitle = document.getElementById(`MobileHeaderTitle-${this.dataset.section}`);
    if (mobileHeaderTitle && this.currentVariant.name) {
      const lastIndex = String(this.currentVariant.name).lastIndexOf(' - ');
      const productName = String(this.currentVariant.name.slice(0, lastIndex));
      mobileHeaderTitle.textContent = productName;
    }
  }

  updateStickyHeaderPrice() {
    // Update mobile sticky header price when variant changes
    const mobileHeaderPrice = document.querySelector(
      `.mobile-sticky-header__details > .mobile-sticky-header__price > div`,
    );

    if (mobileHeaderPrice) {
      const regularPriceElement = mobileHeaderPrice.querySelector('.price__regular .price-item--regular');
      const salePriceElement = mobileHeaderPrice.querySelector('.price__sale .price-item--sale');
      const compareAtPriceElement = mobileHeaderPrice.querySelector('.price__sale .price-item--compare');
      const updatedSalePrice = this.currentVariant.price;
      const updatedComparePrice = this.currentVariant.compare_at_price;
      const isOnSale = updatedComparePrice > updatedSalePrice;

      if (isOnSale) {
        this.updateSalePrice(
          updatedSalePrice,
          updatedComparePrice,
          regularPriceElement,
          salePriceElement,
          compareAtPriceElement,
        );
        mobileHeaderPrice.classList.add('price--on-sale');
      } else {
        this.updateRegularPrice(updatedSalePrice, regularPriceElement, salePriceElement, compareAtPriceElement);
        mobileHeaderPrice.classList.remove('price--on-sale');
      }

      mobileHeaderPrice.classList.remove('visibility-hidden');
    }
  }

  updateStickyHeaderImage() {
    // Update mobile sticky header image when variant changes
    const mobileHeaderImage = document.getElementById(`MobileHeaderImage-${this.dataset.section}`);
    if (mobileHeaderImage && this.currentVariant.featured_media) {
      const newSrc = this.currentVariant.featured_media.preview_image.src;
      if (newSrc) {
        // Update srcset for responsive images
        const imgWidth = this.currentVariant.featured_media.preview_image.width;
        let srcset = '';

        if (imgWidth >= 120) {
          srcset += `${this.currentVariant.featured_media.preview_image.src.replace(
            /\.(jpg|jpeg|png|gif|webp)/i,
            `_120x.$1`,
          )} 120w`;
        }

        if (imgWidth >= 240) {
          srcset += `, ${this.currentVariant.featured_media.preview_image.src.replace(
            /\.(jpg|jpeg|png|gif|webp)/i,
            `_240x.$1`,
          )} 240w`;
        }

        if (imgWidth >= 360) {
          srcset += `, ${this.currentVariant.featured_media.preview_image.src.replace(
            /\.(jpg|jpeg|png|gif|webp)/i,
            `_360x.$1`,
          )} 360w`;
        }

        mobileHeaderImage.srcset = srcset;
        mobileHeaderImage.src = this.currentVariant.featured_media.preview_image.src.replace(
          /\.(jpg|jpeg|png|gif|webp)/i,
          `_120x.$1`,
        );
        mobileHeaderImage.alt = this.currentVariant.featured_media.alt || this.currentVariant.title;
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);

const preloadProducts = () => {
  const loadedProductIds = Array.from(
    document.querySelectorAll('.grid__item.product__media-wrapper .product__media-gallery'),
  ).map((mediaGallery) => mediaGallery.dataset.productId);
  const productSectionalInputs = document.querySelectorAll('.sectionals .product-form__input-wrapper input');
  productSectionalInputs.forEach((productSectionalInput) => {
    if (!loadedProductIds.includes(productSectionalInput.dataset.productId)) {
      fetch(productSectionalInput.dataset.url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const configuratorOptions = document.querySelector('.configurator-options-wrapper variant-radios');
          const productMediaGallery = html.querySelector('media-gallery');
          if (productMediaGallery.dataset.productId != configuratorOptions.currentProductId) {
            productMediaGallery.classList.add('hidden');
          }
          const parentDiv = document.querySelector('.grid__item.product__media-wrapper');
          parentDiv.appendChild(productMediaGallery);
        });
    }
  });
};
document.addEventListener('DOMContentLoaded', preloadProducts);
